// extracted by mini-css-extract-plugin
module.exports = {"container":"sf","square":"sh","slide":"si","show":"sj"};